import * as React from "react";

interface IReadOnlyFieldWrapper {
  value: any;
  children: React.ReactNode;
}

const ReadOnlyFieldWrapper = (props: IReadOnlyFieldWrapper) => {
  const { value, children } = props;
  if (value) {
    return <>{children}</>;
  }
  return null;
};

export default ReadOnlyFieldWrapper;
